import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})

export class LanguageService {
  private currentLang = new BehaviorSubject<string>('es');

  constructor(
    private translate: TranslateService,
    private platform: Platform,
    private http: HttpClient
  ) { }

  setDefaultLanguage() {
    let langToUse;
    if(environment.APP_MULTIMARCA || environment.SERVICE_BASE.includes("test5")) {
      const browserLang = localStorage.getItem('preferredLanguage') || this.translate.getBrowserLang();
      langToUse = browserLang.match(/en|es/) ? browserLang : 'es';
    } else {
      langToUse = "es";
    };

    // console.log("browserLang::" ,langToUse)

    this.changeLanguage(langToUse);
  }

  changeLanguage(lang: string) {
    // console.log("language service - changeLanguage:: ",lang)
    localStorage.setItem('preferredLanguage', lang);
    // Actualizar el idioma
    this.setDefaultLang(lang);
    this.translate.use(lang);

    this.currentLang.next(lang);
  }

  setDefaultLang(lang) {
    this.translate.setDefaultLang(lang);
  }

  getCurrentLang() {
    return this.currentLang.asObservable();
  }

  logoutTranslate(lang) {
    return lang === "es" ?
    {
      title: "Cerrar Sesión",
      msg: "¿Seguro que deseas salir de la aplicación?",
    }
    :
    {
      title: "Log out",
      msg: "Are you sure you want to log out?",
    };
  }

  cancelTranslate(lang) {
    return lang === "es" ? "Cancelar" : "Cancel";
  }

  acceptTranslate(lang) {
    return lang === "es" ? "Aceptar" : "Accept";
  }

  continueTranslate(lang) {
    return lang === "es" ? "Continuar" : "Continue";
  }

  ValidatingTranslate(lang) {
    return lang === "es" ? "Verificando" : "Validating";
  }

  logInMsg1(lang) {
    return lang === "es" ?
    "Tu contraseña necesita ser actualizada, por favor realiza el cambio de la misma."
     : "Your password needs to be updated. Please change it.";
  }

  logInMsg2(lang, resetDays) {
    return lang === "es" ?
    `Tu contraseña no se ha actualizado en ${resetDays} días, actualízala ahora.`
    : `Your password hasn't been updated in ${resetDays} days. Please update it now.`
  }

  logInMsg3(lang) {
    return lang === "es" ?
    "No lograste ingresar. Por favor ingresa los datos correctos."
    : "Login failed. Please make sure your information is correct."
  }

  logInMsg4(lang) {
    return lang === "es" ?
    "No se ha podido encontrar tu cuenta. Por favor ingresa los datos correctos."
    : "We couldn't find your account. Please make sure the information you entered is correct."
  }

  logInMsgReCaptcha(lang) {
    return lang === "es" ?
    "Error en validación reCAPTCHA, por favor vuelva a intentarlo."
    : "reCAPTCHA validation error, please try again."
  }

  logInMsg5(lang) {
    return lang === "es" ?
    "No lograste ingresar. Por favor vuelve a intentarlo."
    : "Login attempt failed. Please try again."
  }
  passwordMsg1(lang) {
    return lang === "es" ?
    "No se ha podido actualizar tu contraseña. Por favor vuelva a intentarlo."
    : "Your password could not be updated. Please try again."
  }
  readFileError(lang) {
    return lang === "es" ?
    "Asegúrate de que esté descargado en el almacenamiento de tu dispositivo antes de seleccionarlo."
    : "To use this file, it must be stored on your device. Please make sure the file is saved and try again."
  }
  readFileErrorTitle(lang) {
    return lang === "es" ?
    "No se pudo leer el archivo"
    : "The file couldn't be read"
  }
  alertTitle(lang) {
    return lang === "es" ?
    "Alerta"
    : "Alert"
  }

  getOfflineTranslate(lang) {
    if(lang === "es") {
      return this.http.get('assets/i18n/offlineMsg/es.json');
    } else {
      return this.http.get('assets/i18n/offlineMsg/en.json');
    }
  }
  getChecklistTranslateFile(lang) {
    if(lang === "es") {
      return this.http.get('assets/i18n/checklist/activities/es.json');
    } else {
      return this.http.get('assets/i18n/checklist/activities/en.json');
    }
  }
  getListChecklistTranslateFile(lang) {
    if(lang === "es") {
      return this.http.get('assets/i18n/checklist/es.json');
    } else {
      return this.http.get('assets/i18n/checklist/en.json');
    }
  }
  getResultChecklistTranslateFile(lang) {
    if(lang === "es") {
      return this.http.get('assets/i18n/checklist/es.json');
    } else {
      return this.http.get('assets/i18n/checklist/en.json');
    }
  }
  getGlobalTranslateFile(lang) {
    if(lang === "es") {
      return this.http.get('assets/i18n/app/es.json');
    } else {
      return this.http.get('assets/i18n/app/en.json');
    }
  }
  getRewardTranslateFile(lang) {
    if(lang === "es") {
      return this.http.get('assets/i18n/rewards/es.json');
    } else {
      return this.http.get('assets/i18n/rewards/en.json');
    }
  }


}
